import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { dataTestIds } from 'src/constants/data-test-ids';
import {
  SectionHeading,
  useNoteSectionTitleInCardHeader,
} from 'src/features/visits/shared/components/NoteSectionHeading';
import { useVisitNote } from '../../../hooks/useVisitNote';

/**
 * Legacy container for charts with ros data saved via the free text field.
 */
export const ReviewOfSystemsContainer: FC = () => {
  const titleInCardHeader = useNoteSectionTitleInCardHeader();
  const { data: note } = useVisitNote();
  const ros = note?.encounterNotes.ros?.text;

  if (!ros) return null;

  const formattedRos = ros.replace(/\\n/g, '\n');

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}
      data-testid={dataTestIds.telemedEhrFlow.reviewTabRosContainer}
    >
      {!titleInCardHeader && <SectionHeading>Review of systems</SectionHeading>}
      <Typography sx={{ whiteSpace: 'pre-wrap' }}>{formattedRos}</Typography>
    </Box>
  );
};
